import "./Summary.css";
import SummaryCard from "../../components/summaryCard/SummaryCard.jsx";
import SummaryChartCard from "../../components/summaryChartCard/SummaryChartCard.jsx";
import SubHeaderLinks from "../../components/subHeaderLinks/SubHeaderLinks.jsx";
import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { getUserSummaryRequest } from "../../services/wisdomServices/reportService";
import { requestGetAnnouncement } from "../../services/wisdomServices/announcementService";
import { getSessionItem, setSessionItem } from "../../utils/helper/session";
import { Calendar } from "primereact/calendar";
import { FloatLabel } from "primereact/floatlabel";
import { Message } from "primereact/message";
import { SelectButton } from "primereact/selectbutton";
import { getAgentProjectsRequest } from "../../services/wisdomServices/projectService";
import { getUserWeatherData } from "../../services/externalServices/ipapiService.js";
import WeatherCard from "../../components/weatherCard/weatherCard.jsx";
import { Card } from "primereact/card";
import { Joyride } from "react-joyride";;
import { useOnboarding } from "../../context/onboardingContext.jsx";
import MyAchivementsCard from "../../components/myAchievementsCard/MyAchivementsCard.jsx";
import BirthdaysCard from "../../components/birthdaysCard/BirthdaysCard.jsx";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { LuNotebookTabs } from "react-icons/lu";
import KudosCard from "../../components/kudosCard/KudosCard.jsx";
import RecentKudosDialog from "../../components/recentKudosDialog/RecentKudosDialog.jsx";

function Summary() {
  const navigate = useNavigate();
  const { runTour, setRunTour, goToNextPage } = useOnboarding();
  const user = getSessionItem("User");
  const today = React.useMemo(() => new Date(), []);
  const [weather, setWeather] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(1);
  const [kudosRefreshKey, setKudosRefreshKey] = useState(0);
  const [dates, setDates] = useState([today,today]);
  const [openKudosDialog, setOpenKudosDialog] = useState(false);
  const [summary, setSummary] = useState({
    totalTime: 0,
    activeTime: 0,
    idleTime: 0,
    markedCards: 0,
    manualTime: 0,
    approvedOT: 0,
    rejectedTime: 0,
    overtime: 0,
  });
  const [announcement, setAnnouncement] = useState(null);

  if (!user?.id) {
    return null; 
  }
  
  useEffect(() => {
    if (!user?.id) return;

    const storageKey = `recentKudosShown_${user.id}`;
    const alreadyShown = sessionStorage.getItem(storageKey);

    if (alreadyShown === "true") return;

    sessionStorage.setItem(storageKey, "true");
    setOpenKudosDialog(true);
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id || !dates?.[0] || !dates?.[1]) return;
    loadSummary(dates);
  }, [dates, user?.id]);

  useEffect(() => {
    if (!user?.id) return;
    getUserProjects(user.id, user.role);
  }, [user?.id]);

  useEffect(() => {
    const loadAnnouncement = async () => {
      const cached = sessionStorage.getItem("announcement");
      if (cached) {
        setAnnouncement(cached);
        return;
      }

      try {
        const response = await requestGetAnnouncement();
        if (response?.announcement) {
          setAnnouncement(response.announcement);
          sessionStorage.setItem("announcement", response.announcement);
        }
      } catch (error) {
        console.error("Failed to load announcement:", error);
      }
    };

    loadAnnouncement();
  }, []);

  useEffect(() => {
    const handler = (event) => {
      if (event.data?.action === "refresh" && getSessionItem("User")) {
        window.location.reload();
      }
    };

    navigator.serviceWorker?.addEventListener("message", handler);
    return () => navigator.serviceWorker?.removeEventListener("message", handler);
  }, []);


  useEffect(() => {
    const cached = getSessionItem("location");

    if (cached) {
      setWeather(cached);
      return;
    }

    const fetchWeather = async () => {
      try {
        const data = await getUserWeatherData();
        setWeather(data);
        setSessionItem("location", data);
      } catch (error) {
        console.error("Weather fetch failed:", error);
      }
    };

    fetchWeather();
  }, []);
  
  useEffect(() => {
    const user = getSessionItem("User");

    if (user?.isFirstLogin) {
      setRunTour(true);
    }
  }, []);

  const handleOpenRecentKudos = () => {
    setOpenKudosDialog(true);
  };

  const handleKudosCreated = () => {
    setKudosRefreshKey((prev) => prev + 1);
  };
  
  const limit = [5, 10, 15, 20];
  const items = [
    {name: 'Daily', value:1},
    {name: 'Weekly', value:2},
    {name: 'Monthly', value:3}
  ]
  
  const loadSummary = async (range) => {
    if (!range?.[0] || !range?.[1]) return;

    const start = moment(range[0]).format("YYYY-MM-DD");
    const end = moment(range[1]).format("YYYY-MM-DD");

    try {
      const data = await getUserSummaryRequest(user.id, start, end);
      setSummary({
        totalTime: data.totalTime,
        activeTime: data.activeTime,
        idleTime: data.idleTime,
        markedTime: data?.markedCards,
        manualTime: data.requested,
        approvedOT: data.approvedOt,
        rejectedTime: data.rejectedTime,
        overtime: data.overtime,
      });
    } catch (error) {
      console.error("Failed to load summary:", error);
    }
  };

  const handleDateRangeChange = async(e) => {
    setDates(e.value)
    loadSummary(e.value)
  }

  const handlePeriodChange = (e) => {
    const value = e.value;
    setSelectedPeriod(value);

    const today = moment();
    let range = [];

    switch (value) {
      case 1:
        range = [
          today.toDate(),
          today.toDate()
        ];
        break;

      case 2:
        range = [
          today.clone().startOf("isoWeek").toDate(),
          today.toDate()
        ];
        break;

      case 3:
        range = [
          today.clone().startOf("month").toDate(),
          today.toDate()
        ];
        break;

      default:
        return;
    }

    setDates(range);
    loadSummary(range);
  };

  const getUserProjects = async (userId, userRole) => {
  
    if(userRole != 2 || userRole != 4 || userRole != 7){
      let managerProjects = await getAgentProjectsRequest(userId, false, true, 1, 100)
      setSessionItem("projects", managerProjects.data);
    }
    
  };

  const handleJoyrideCallback = (data) => {
    const { action, index, type } = data;

    if (
      type === "step:after" &&
      action === "next" &&
      index === steps.length - 1
    ) {
      goToNextPage();
    }
  };

  const steps = [
    {
      target: "#summary-weather-news",
      content: "Here you can see the current weather and important company announcements.",
      title: "Summary page",
      disableBeacon: true
    },
    {
      target: "#summary-calendar",
      title: "Sirius Calendar",
      content: "This is a global sirius calendar with company wide events"
    },
    {
      target: "#summary-date-controls",
      title: "Date controls",
      content: "Use these controls to filter your tracked time by date range or period."
    },
    {
      target: "#summary-cards",
      title: "Tracked cards",
      content: "These cards display a detailed breakdown of your tracked, idle, manual and overtime hours."
    },
    {
      target: "#summary-chart",
      title: "Productivity chart",
      content: "This chart shows your productivity distribution visually."
    }
  ];
  
  return (
    <div className="user-summary-container">
      <Joyride
        steps={steps}
        run={runTour}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        locale={{
          next: "Next",
          last: "Next Page",
          skip: "Skip tour",
          back: "Back"
        }}
        styles={{
          options: {
            primaryColor: "#0BADDE",
            zIndex: 10000
          },
          tooltip: {
            borderRadius: "8px"
          },
          buttonNext: {
            backgroundColor: "#0BADDE"
          }
        }}
      />

      <div className="employee-summary-main">
        <div className="my-dashboard-header">
          <SubHeaderLinks />
        </div>

        <div className="my-summary-container">
          <div className="my-summary-column">
            {/* GROUP 1 */}
            <div
              className="my-summary-inputs-box dashboard-card"
              id="summary-weather-news"
            >
              <div>
                {weather && (
                  <WeatherCard
                    temperature={weather.temperature}
                    temperatureSign={weather.temperature_2m}
                    regionCode={weather.region_code}
                    city={weather.city}
                    country={weather.country}
                    windSpeed={weather.windSpeed}
                    weatherCode={weather.weatherCode}
                  />
                )}
              </div>

              <div>
                <Card
                  title={
                    <div className="card-title-with-icon">
                      <i className="pi pi-exclamation-circle card-title-icon"></i>
                      <span>Important news</span>
                    </div>
                  }
                  className="my-summary-announcement-card"
                >
                  <p>{announcement}</p>
                </Card>
              </div>
            </div>

            {/* GROUP 4 */}
            <div className="my-summary-tracker-info-box dashboard-card">
              <div className="summary-charts-values">
                <div
                  className="employee-summary-input-group"
                  id="summary-date-controls"
                >
                  <div className="employee-calendar-input-group">
                    <div className="my-summary-inputs">
                      <FloatLabel>
                        <Calendar
                          maxDate={today}
                          value={dates}
                          selectionMode="range"
                          readOnlyInput
                          hideOnRangeSelection
                          inputId="employee-summary-date-range-selector"
                          onChange={handleDateRangeChange}
                          style={{ height: "25px" }}
                          selectOtherMonths={true}
                        />

                        <label
                          style={{ display: "none", opacity: 0 }}
                          htmlFor="employee-summary-date-range-selector"
                        >
                          Select a date range
                        </label>
                      </FloatLabel>
                    </div>

                    <div className="my-summary-inputs">
                      <SelectButton
                        options={items}
                        value={selectedPeriod}
                        onChange={handlePeriodChange}
                        optionLabel="name"
                        className="summary-select-button"
                      />
                    </div>

                    <div className="my-summary-inputs">
                      <Message
                        severity="info"
                        title="All time in the summary is on the UTC timezone"
                        text="All time is on the UTC timezone"
                        className="summary-message"
                      />
                    </div>
                  </div>
                </div>

                <div className="my-summary-productivity-box">
                  <div
                    className="employee-summary-cards"
                    id="summary-cards"
                  >
                    <SummaryCard
                      title="Tracked Time"
                      cardtime={summary.activeTime}
                      info="Your total tracked time via the wisdom tracker."
                    />

                    <SummaryCard
                      title="Idle Time"
                      cardtime={summary.idleTime}
                      info="Your total Idle time, idle timecards are the ones without activity."
                    />

                    <SummaryCard
                      title="Manual Time"
                      cardtime={summary.manualTime}
                      info="Manual Time is a way to add time to your diary without having to track. This must be approved by your manager."
                    />

                    <SummaryCard
                      title="Marked Time"
                      cardtime={summary.markedTime}
                      info="Marked as active time."
                    />

                    <SummaryCard
                      title="Approved OT"
                      cardtime={summary.approvedOT}
                      info="The amount of approved Overtime in the wisdom dashboard. This will allow you to track over the project cap, the time still must be tracked via the tracker."
                    />

                    <SummaryCard
                      title="Rejected Time"
                      cardtime={summary.rejectedTime}
                      info="A sum of timecards that have been rejected by the manager"
                    />

                    <SummaryCard
                      title="Overtime"
                      cardtime={summary.overtime}
                      info="Total tracked time that went above the project Cap - This is what is included in the payroll"
                    />

                    <SummaryCard
                      title="Payroll Time"
                      cardtime={summary.totalTime}
                      info="Tracked Time + approved Manual Time."
                    />
                  </div>

                  <div
                    className="my-summary-productivity-chart"
                    id="summary-chart"
                  >
                    <div>
                      <h4>Productivity Time</h4>
                    </div>

                    <div>
                      <SummaryChartCard
                        chartTitle="Productivity Score"
                        Productive={summary.activeTime}
                        Idle={summary.idleTime}
                        Manual={summary.manualTime}
                        Overtime={summary.overtime}
                        MarkedTime={summary.markedTime}
                        Total={summary.totalTime}
                        productivityRate={summary.totalTime}
                      />
                    </div>
                  </div>

                  <div className="summary-diary-cta">
                    <div className="summary-diary-cta-content">
                      <span className="summary-diary-cta-icon">
                        <LuNotebookTabs />
                      </span>

                      <div>
                        <h4>View your work diary</h4>

                        <p>
                          See your tracked activities, manual entries and daily
                          productivity details.
                        </p>
                      </div>
                    </div>

                    <Button
                      type="button"
                      label="Open diary"
                      icon="pi pi-arrow-right"
                      iconPos="right"
                      className="summary-diary-button"
                      onClick={() => navigate("/diary")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="my-summary-column">
            {/* GROUP 3 */}
            <div
              className="my-summary-infos-box dashboard-card"
              id="summary-infos"
            >
              <div>
                <MyAchivementsCard />
              </div>

              <div>
                <BirthdaysCard />
              </div>

              <div>
                <KudosCard 
                  onKudosCreated={handleKudosCreated}
                  onOpenRecentKudos={handleOpenRecentKudos}
                />
              </div>
            </div>

            {/* GROUP 2 */}
            <div
              className="my-summary-calendar-box dashboard-card"
              id="summary-calendar"
            >
              <div className="summary-iframe-container">
                <iframe
                  src="https://teamup.com/ksgpjqfsrmqu2ek1x7?view=m&tz=Calendar%20default&showHeader=0&showLogo=0&showProfileAndInfo=0&disableSidepanel=1&showTitle=0&showViewSelector=0&showMenu=0&showViewHeader=0&showAgendaDetails=0&listGroupBy=month&showDateControls=1&showDateRange=1&tilesGroupBy=month"
                  loading="lazy"
                  className="summary-iframe"
                  title="Sirius calendar"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RecentKudosDialog
        visible={openKudosDialog}
        onHide={() => setOpenKudosDialog(false)}
        refreshKey={kudosRefreshKey}
      />
    </div>
  );
}

export default Summary;
